import { minWidth, maxWidth, range } from '../utils/mediaQuery';
export const RESULTS_TABLE_BREAKPOINTS = {
  xsmall: maxWidth('544'),
  small: range('545', '1280'),
  medium: range('1281', '1920'),
  large: minWidth('1921')
};
export const DEFAULT_SIZE_SMALL = 'small';
export const DEFAULT_GRID_SIZE_SMALL = 'small';
export const BREAKPOINT_SMALL = 544;
export const BREAKPOINT_MEDIUM = 768;
export const BREAKPOINT_LARGE = 992;
export const BREAKPOINT_EXTRA_LARGE = 1200;
export const BREAKPOINTS = {
  small: maxWidth(BREAKPOINT_MEDIUM - 1),
  medium: range(BREAKPOINT_MEDIUM, BREAKPOINT_LARGE - 1),
  large: range(BREAKPOINT_LARGE, BREAKPOINT_EXTRA_LARGE - 1),
  xlarge: minWidth(BREAKPOINT_EXTRA_LARGE)
};